export default __webpack_public_path__ + "static/media/tutorialWeb-3.12.65c48667.png";